// In src/components/ConfirmDeleteModal.js

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, itemName, isDeleting }) => {
    if (!isOpen) return null;

    return (
        <AnimatePresence>
            <div className="fixed inset-0 bg-black/50 z-[100] flex items-center justify-center p-4">
                <motion.div
                    className="bg-white rounded-lg shadow-xl w-full max-w-sm p-6"
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.9, opacity: 0 }}
                >
                    <h3 className="text-lg font-bold text-gray-800">Confirm Deletion</h3>
                    <p className="text-gray-600 my-4">
                        Are you sure you want to permanently delete this {itemName || 'item'}? This action cannot be undone.
                    </p>
                    <div className="flex justify-end space-x-4">
                        <button 
                            onClick={onClose} 
                            disabled={isDeleting}
                            className="px-4 py-2 text-gray-700 rounded-md hover:bg-gray-100 disabled:opacity-50"
                        >
                            Cancel
                        </button>
                        <button 
                            onClick={onConfirm}
                            disabled={isDeleting}
                            className="px-4 py-2 bg-red-600 text-white font-semibold rounded-md hover:bg-red-700 disabled:bg-red-400"
                        >
                            {isDeleting ? 'Deleting...' : 'Delete'}
                        </button>
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
};

export default ConfirmDeleteModal;